import { extendTailwindMerge } from 'tailwind-merge';

import { TEXT_ROLES } from '../theme/generated/roles';

/**
 * tailwind-merge configured for the Cobrainer theme. Without the text roles,
 * tailwind-merge reads `text-ui` as a text colour and drops it whenever a
 * later `text-text-*` colour class appears. The motion scale (theme/studio-motion.css)
 * and the panel and dialog animations (theme/animations.css) are registered for the same reason,
 * so `duration-quick` replaces `duration-200` and `animate-none` replaces `animate-dialog-in`.
 */
export const mergeClassNames = extendTailwindMerge({
    extend: {
        theme: {
            // `xxs` and `xxxs` are the legacy size names kept for upstream components.
            text: ['xxs', 'xxxs', ...TEXT_ROLES],
            ease: ['standard', 'enter', 'bounce'],
            animate: ['panel-in', 'dialog-in', 'dialog-out'],
        },
        classGroups: {
            duration: [{ duration: ['instant', 'quick', 'standard', 'deliberate', 'emphasis'] }],
        },
    },
});
